import "core-js/stable";
import(/* webpackChunkName: 'regenerator' */ "regenerator-runtime/runtime");

require("@rails/ujs").start();

// import Turbolinks from "turbolinks";

// Turbolinks.start();
// window.Turbolinks = Turbolinks;
import $ from "jquery";
//import "jquery.scrollto";
//import {} from "jquery-ujs";

//import "jquery_lazyload/jquery.lazyload";
import(/* webpackChunkName: 'attach_auto' */ "lib/attach_autocomplete");
require("lib/jquery_ext");
//import(/* webpackChunkName: 'retina' */ "lib/handle_retina");

import JangoSplash from "jango/splash/jango_splash";
window._jangoSplash = new JangoSplash();
